import { Participation, ParticipationStatus } from '@app/api';
import moment from 'moment-timezone';
import _forEach from 'lodash/forEach';
import { Logger } from './logger';
import { Colors } from '@app/theme';

type ParticaptionMap = {
  [status in ParticipationStatus]: Participation[];
};

export const orderParticipationsByStatus = (
  participations: Participation[],
) => {
  const res: ParticaptionMap = {
    invited: [],
    applied: [],
    accepted: [],
    booked: [],
    participated: [],
    payment_requested: [],
    processing_payment: [],
    in_progress: [],
    payed: [],
    declined: [],
    canceled: [],
    out_of_quota: [],
    noshow: [],
    not_interested: [],
  };
  participations.forEach((part: Participation) => {
    try {
      const status = part.status;
      res[status].push(part);
    } catch (e) {
      Logger.warnError(e, { id: part.id });
    }
  });
  _forEach(res, (ppts) => {
    ppts.sort((a1, a2) =>
      a1.appointment && a2.appointment
        ? // appointemnt date asc
          moment(a1.appointment.date).diff(a2.appointment.date)
        : // update date desc
          moment(a2.updatedAt).diff(a1.updatedAt),
    );
  });

  return res;
};

const statusColors: {
  [status in ParticipationStatus]: Colors;
} = {
  invited: 'purple',
  applied: 'blue',
  accepted: 'yellow',
  booked: 'accent',
  in_progress: 'accent',
  participated: 'green',
  payment_requested: 'blue',
  processing_payment: 'blue',
  payed: 'blue',
  canceled: 'red',
  declined: 'red',
  out_of_quota: 'inkTertiary',
  noshow: 'red',
  not_interested: 'red',
};

export const getColorForParticipationStatus = (
  status: ParticipationStatus,
): Colors => {
  return statusColors[status];
};
